import { useEffect, useState } from "react";

const sample = (video, canvas) => {
  const ctx = canvas.getContext("2d");
  ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);
  let total = 0;
  for (let i = 0; i < data.length; i += 4) {
    total += 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
  }
  return total / (data.length / 4);
};

// Average luminance of the live preview (0-255) so we can warn about poor lighting.
export const useLightMeter = (videoRef, active) => {
  const [luma, setLuma] = useState(null);

  useEffect(() => {
    if (!active) return undefined;
    const canvas = document.createElement("canvas");
    canvas.width = 48;
    canvas.height = 48;
    const timer = setInterval(() => {
      const video = videoRef.current;
      if (!video || !video.videoWidth) return;
      try {
        const next = Math.round(sample(video, canvas));
        setLuma((prev) => (prev !== null && Math.abs(prev - next) < 8 ? prev : next));
      } catch {
        setLuma(null);
      }
    }, 3000);
    return () => clearInterval(timer);
  }, [videoRef, active]);

  return { luma, tooDark: luma !== null && luma < 60, tooBright: luma !== null && luma > 235 };
};
